export default {
  contact: 'اتصل بنا',
  emailTitle: 'مراسلتنا على البريد الاليكتروني',
  emailSubTitle: 'تواصل مع محلل دعم التاجر',
  subject: 'موضوع',
  message: 'رسالتك',
  btn: 'أرسل رسالة',
};
